<template>
    <b-container id="home-page" class="pt-3 px-3" fluid="">
        <h1 class="mt-3 mx-3"> {{ $t('home.welcome.title') }}</h1>
        <p class="mx-3 text-left">
            {{ $t('home.welcome.text') }}. {{ $t('home.welcome.demovideotext')}}
            <a target="_blank" :href="videoUrl.url">
                {{ $t('home.welcome.demovideolink') }}
            </a>.
        </p>
        <br>
        <b-row class="my-5 mx-3">
            <b-col cols="6" md="3" class="text-center">
                <img src="@/assets/home/icono_personas.svg" alt="">
                <h2>{{ data.patients }} {{ $tc('home.patient', data.patients) }}</h2>
                <p>{{ $t('home.patients') }}</p>
            </b-col>
            <b-col cols="6" md="3" class="text-center">
                <img src="@/assets/home/icono_novo8.svg" alt="">
                <h2>{{ data.novoeight | formatNumber }} UI</h2>
                <p>{{ $t('home.novoeight') }}</p>
            </b-col>
            <b-col cols="6" md="3" class="text-center">
                <img src="@/assets/home/icono_bisturi.svg" alt="">
                <h2>{{ data.surgeries }} {{ $tc('home.surgery', data.surgeries) }}</h2>
                <p>{{ $t('home.surgeries') }}</p>
            </b-col>
            <b-col cols="6" md="3" class="text-center">
                <img src="@/assets/home/icono_hospital.svg" alt="">
                <h2>{{ data.centers }} {{ $tc('home.center', data.centers) }}</h2>
                <p>{{ $t('home.centers') }}</p>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import api from "@/api/api";

    export default {
        name: 'HomePage',
        components: {},
        filters: {
            formatNumber(number) {
                return number.toLocaleString('en-US').replace(new RegExp(',', 'g'), ' ');
            }
        },
        data() {
            return {
                data: {
                    centers: '-',
                    novoeight: '-',
                    patients: '-',
                    surgeries: '-',
                },
            };
        },
        computed: {
            videoUrl() {
                return {
                    url: process.env.VUE_APP_SERVERURL + 'media/private/demo.mp4',
                    name: 'Video demostración',
                };
            }
        },
        async created() {
            this.data = await api.getHome();
        },
    };
</script>

<style scoped lang="scss">
    @import "src/custom.scss";

    h1, h2 {
        @extend .text-primary;
    }

    h2, p {
        @extend .text-center;
    }

    h2 {
        @extend .font-weight-bold;
    }

</style>
